export default "__VITE_ASSET__BaoqYV6f__";